import CloudMount from "../assets/walls/CLOUDYMOUNTAIN_2560x1440.png";
import Duality from "../assets/walls/DUALITY_2560x1440.png";
import DustMount from "../assets/walls/DUSTMOUNTTREE_2048x1080.png";
import MatSea from "../assets/walls/MATSEA_1920x1080.png";
import Land from "../assets/walls/NOTSAMURAI_1920x1080.png";
import SkyMount from "../assets/walls/SKYMOUNTBLUE_1920x1080.png";
import SkyMountV2 from "../assets/walls/SKYMOUNTV2_2560x1440.png";
import MatGlowLight from "../assets/walls/MATGLOWLIGHT_1920x1080.png";

export const wallList = [
  {
    name: "Cloud Mount",
    details: "This app does this",
    coverImage: CloudMount,
    resolution: "2560x1440",
    downloadCount: 1,
    downloadLink: "download link",
  },
  {
    name: "Mat Sea",
    details: "This app does this",
    coverImage: MatSea,
    resolution: "1920x1080",
    downloadCount: 1,
    downloadLink: "download link",
  },
  {
    name: "Sky Mount V2",
    details: "This app does this",
    coverImage: SkyMountV2,
    resolution: "2560x1440",
    downloadCount: 1,
    downloadLink: "download link",
  },
  {
    name: "Sky Mount",
    details: "This app does this",
    coverImage: SkyMount,
    resolution: "1920x1080",
    downloadCount: 1,
    downloadLink: "download link",
  },
  {
    name: "Dust Mount",
    details: "This app does this",
    coverImage: DustMount,
    resolution: "2048x1080",
    downloadCount: 1,
    downloadLink: "download link",
  },
  {
    name: "Land",
    details: "This app does this",
    coverImage: Land,
    resolution: "1920x1080",
    downloadCount: 1,
    downloadLink: "download link",
  },
];
